export default "__VITE_ASSET__4655f8b9__"